<template>
    <div>
        <loading-gdb :propObject="loading"></loading-gdb>
        <div class="title mb-4">
            Atualização de Parcela Inicial <helper-gdb text="Processo de Atualização de Parcela Inicial UNDB"/>
        </div>
        <v-row>
            <v-col cols="12" sm="6">
                <v-select
                    v-model="payload.tipo"
                    label="Tipo Execução"
                    :items="[
                        {value: 's', title: 'Visualização'},
                        {value: 'u', title: 'Atualização'},
                    ]"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4">
                <v-select
                    :disabled="pletivos.length == 0"
                    @update:modelValue="onChangePletivo"
                    return-object
                    label="Id Perlet"
                    :items="pletivos"
                    item-value="idperlet"
                    item-title="nome"
                    ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
                <v-select
                    v-model="payload.parcela_inicial"
                    label="Parc. Inicial"
                    :items="[1,7]"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
                <v-select
                    v-model="payload.nova_parcela_inicial"
                    label="Nova Parc. Inicial"
                    :items="[2,8]"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="12">
                <v-combobox
                    label="Ignorar Bolsas"
                    clearable
                    multiple
                    prepend-inner-icon="mdi-close"
                    v-model="payload.codbolsas_lista_negra"
                    messages="Ignorar alunos com as bolsas"
                ></v-combobox>
            </v-col>
            <v-col cols="12" sm="6">
                <v-textarea
                    clearable
                    v-model="payload.ra_lista_negra"
                    label="Ignorar alteração nos RA`s"
                    messages="Alunos que NÃO sofrerão alteração de parcela"
                    prepend-inner-icon="mdi-close"
                    ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-textarea
                    clearable
                    v-model="payload.ra_lista_branca"
                    prepend-inner-icon="mdi-check"
                    label="Aplicar somente aos RA`s"
                    messages="Alunos que sofrerão alteração de parcela"
                ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12">
                <v-btn @click="set_atualiza_parcela"
                    :color="payload.tipo == 's' ? 'success' : 'error'"
                    :disabled="!payload.parcela_inicial ||
                                !payload.nova_parcela_inicial ||
                                !payload.idperlet_atual"
                    >{{payload.tipo =='s' ? 'Visualizar' : 'Atualizar'}}</v-btn>
            </v-col>
            <v-divider class="my-2"></v-divider>
            <v-col cols="12" sm="12">
                {{(logs_processo||[]).length}} Registro(s)
                <span v-for="l, index in logs_processo" :key="index">
                    <v-alert color="primary">
                        <span>{{l}}</span>
                    </v-alert>
                </span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: ()=>({
        loading: false,
        pletivos: [],
        logs_processo:[],
        payload: {
            tipo: "s",
            parcela_inicial: null,
            nova_parcela_inicial: null,
            idperlet_atual: null,
            codbolsas_lista_negra: ["21","22","196","197","201","224","266","288","390","391","392","406","408","417","428","429","431","446","505","507","525"],
            ra_lista_negra: '',
            ra_lista_branca: '',
        }
    }),
    methods:{
        ...mapActions(['SetAtualizaParcela', 'GetPletivos']),
        async set_atualiza_parcela(){
            if(this.payload.tipo == 'u'){
                const confirma = confirm(`Confirma atualização de parcela Inicial ${this.payload.parcela_inicial} para ${this.payload.nova_parcela_inicial}?`)
                if (!confirma){
                    return
                }
            }
            this.loading = true
            const response = await this.SetAtualizaParcela(this.payload)
            if(response.status == 200){
                this.logs_processo = response.data.processo
            }else{
                this.logs_processo = []
                alert(response.statusText)
            }
            this.loading = false
        },
        async init(){
            const response = await this.GetPletivos( { codtipocurso: [2], top: 10 } )
            if (response.status == 200){
                this.pletivos = response.data
            }
        },
        onChangePletivo(pletivo){
            if (pletivo.codperlet){
                let novaparcela = {
                    1: 2,
                    7: 8
                }
                // atualiza idperlet
                this.payload.idperlet_atual = pletivo.idperlet
                // valida inicial .1
                var ini_dot1 = pletivo.codperlet.indexOf('.1') !== -1 ? 1 : null
                // valida inicial .2
                var ini_dot2 = pletivo.codperlet.indexOf('.2') !== -1 ? 7 : null
                // assume parcela inicial
                var parcela_inicial = ini_dot1 | ini_dot2
                //atualiza parcela inicial
                this.payload.parcela_inicial = parcela_inicial
                this.payload.nova_parcela_inicial =  novaparcela[parcela_inicial]
            }
        }
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading'])
    },
    mounted(){
        this.init()
    }
}
/**
 * 002-022268
002-021444
002-027414
002-026174
002-023569
002-026177
002-025258
002-022584
002-018215
002-021282
002-026342
002-016563
002-022026
002-026907
002-018332
002-003173
002-020298
002-015738
002-027426
002-025298
002-026489
002-022333
002-016563
002-028104
002-026426
002-020940
002-019811
002-019473
002-022321
002-025658
002-025658
002-024120
002-024244
002-027033
002-021615
002-027790
002-027865
002-021615
002-027849
002-027866
002-027962
002-021615
002-027790
002-021615
002-023279
002-026492
002-027015
002-028163
002-024584
002-024222
002-024374
002-022109
002-027634
002-027334
002-026492
002-022822
002-022751
002-024077
002-022454
002-021824
002-027267
002-020524
002-028159
002-026493
002-023504
002-024119
002-025033
002-010119
002-027363
002-023737
002-024249
002-023775
002-021256
002-027142
002-028149
002-028107
002-026444
002-022310
002-010001
002-023730
002-025015
002-018073
002-023439
002-025269
002-023385
002-005034
002-016661
002-024948
002-017425
002-024893
002-027808
002-024152
002-023738
002-027992
002-026982
002-024896
002-021614
002-021704
002-023584
002-010402
002-022300
002-026205
002-019730
002-024493
002-020305
002-028898
002-020268
002-018358
002-020418
002-025633
002-020427
002-026710
002-027652
001-009147
002-021937
002-027665
002-026703
002-008355
002-020946
002-016956
002-021496
002-023328
002-010425
002-021525
002-026981
002-028154
002-023936
002-025935
002-023649
002-025915
002-024873
002-022156
002-027375
002-017460
002-021416
002-022279
002-024681
002-017111
002-026576
002-024189
002-023684
002-015691
002-020770
002-015905
002-026575
002-026166
002-020946
002-021088
002-024681
002-025691
002-018596
002-020112
002-022330
002-021515
002-026734
002-023964
002-021474
002-015905
 */
</script>